// extracted by mini-css-extract-plugin
var _1 = "ProductPrice_price__e23hl";
var _2 = "ProductPrice_retailPrice__gBntx";
export { _1 as "price", _2 as "retailPrice" }
